import { DirectiveOptions } from 'vue';
import autosize from 'autosize';

/**
 * Directive to enable auto-resizing of textareas
 */
export const autoresize: DirectiveOptions = {
	inserted(el: HTMLElement): void {
		autosize(el);
	},

	update(el: HTMLElement): void {
		autosize.update(el);
	},

	unbind(el: HTMLElement): void {
		autosize.destroy(el);
	},
};
